import Vue from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export default () => {
  if (process.client) {
    Vue.use(Toast, {
      transition: "Vue-Toastification__fade",
    });
  }
}